  import { BrowserModule } from '@angular/platform-browser';
  import { CommonModule, HashLocationStrategy, LocationStrategy , PathLocationStrategy} from '@angular/common';
  import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
  import { RouterModule, Routes } from '@angular/router';
  import { NgbDatepickerModule, NgbTimepickerModule } from '@ng-bootstrap/ng-bootstrap';
  import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
  import { Ng2SearchPipeModule } from 'ng2-search-filter';
  import { FormsModule } from '@angular/forms'
  import { ResizableModule } from 'angular-resizable-element';
  import { DragAndDropModule } from 'angular-draggable-droppable';
  //import { DemoComponent, SalesRepTimetableComponent } from './Components/Back-end/sales-rep-timetable/sales-rep-timetable.component';
  import { ReactiveFormsModule} from '@angular/forms'
  import { AppRoutingModule } from './app-routing.module';
  import { AppComponent, SafePipe } from './app.component';
  import { WelcomeComponent } from './Components/Front-end/welcome/welcome.component';
  import { MainMenuComponent } from './Components/Front-end/main-menu/main-menu.component';
  import { CovidAssessmentComponent } from './Components/Front-end/covid-assessment/covid-assessment.component';
  import { AppointmentQuestionaireComponent } from './Components/Front-end/appointment-questionaire/appointment-questionaire.component';
  import { HaveAppointmentQuestionComponent } from './Components/Front-end/have-appointment-question/have-appointment-question.component';
  import { AppointmentService } from './Services/Appointment/appointment.service';
  import { AppointmentSearchComponent } from './Components/Front-end/appointment-search/appointment-search.component';
  import { MainDashboardComponent } from './Components/Back-end/main-dashboard/main-dashboard.component';
  import { AppointmentDetailsComponent } from './Components/Back-end/appointment-details/appointment-details.component';
  import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
  import { LoginComponent } from './Components/Back-end/login/login.component';
  import { SideBarMenuComponent } from './Components/Back-end/side-bar-menu/side-bar-menu.component';
  import { TopNavBarComponent } from './Components/Back-end/top-nav-bar/top-nav-bar.component';
  import { RegisterComponent } from './Components/Back-end/register/register.component';
  import { UsersComponent } from './Components/Back-end/users/users.component';
  import { IndividualUserFullviewComponent } from './Components/Back-end/individual-user-fullview/individual-user-fullview.component';
  import { AppointmentEditComponent } from './Components/Back-end/appointment-edit/appointment-edit.component';
  import { DatePipe } from '@angular/common';
import { ExcelService } from './Services/ExcelService/excel.service';
  import { AuthGuardService } from 'src/app/Services/Authentication/AuthGuard/auth-guard.service';
  import { SalesRepHomeComponent } from './Components/Back-end/SalesRep/Home/sales-rep-home/sales-rep-home.component';
  import { CalendarModule, DateAdapter } from 'angular-calendar';
  import { adapterFactory } from 'angular-calendar/date-adapters/date-fns'
  //import { DemoUtilsModule } from '../demo-utils/module';
  import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
  import { DemoUtilsModule } from '../utils/module';
  import { AllLocalAppointmentsComponent } from './Components/Back-end/all-local-appointments/all-local-appointments.component';
  import { LunchAssignmentComponent } from './Components/Back-end/lunch-assignment/lunch-assignment.component';
  import { CreateAppointmentComponent } from './Components/Back-end/create-appointment/create-appointment.component';
  import { DayViewSchedulerComponent } from './Components/Back-end/day-view-scheduler/day-view-scheduler.component';

  import { SalesRepTimetableComponent } from './Components/Back-end/sales-rep-timetable/sales-rep-timetable.component';
  import { CalendarNativeDateFormatter, CalendarDateFormatter } from 'angular-calendar';
  import { ReportDashboardComponent } from './Components/Back-end/Report/report-dashboard/report-dashboard.component';
  import { LogisticsMainComponent } from './Components/Back-end/Logistics/logistics-main/logistics-main.component';
  import { CreateLogisticsSchedulesComponent } from './Components/Back-end/Logistics/create-logistics-schedules/create-logistics-schedules.component';
  import { ScheduleDetailsComponent } from './Components/Back-end/Logistics/schedule-details/schedule-details.component';
  import { ScheduleEditComponent } from './Components/Back-end/Logistics/schedule-edit/schedule-edit.component';

  import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
  import { DateTimePickerComponent } from './Components/date-time-picker/date-time-picker/date-time-picker.component';
  import { AvailableAppointmentSlotComponent } from './Components/available-appointment-slot/available-appointment-slot.component';
  import { MatButtonModule } from '@angular/material/button';
  import { ExternalLoginComponent } from './Components/external-login/external-login.component';
  import { ScheduleAdministrationComponent } from './Components/Back-end/schedule-administration/schedule-administration.component';
  import { BranchReportComponent } from './Components/Back-end/Report/branch-report/branch-report.component';
  import {DragDropModule} from '@angular/cdk/drag-drop';

  import { speedDialFabAnimations } from './Components/speed-dial-fab.animations';
  import { ClientDetailsComponent } from './Components/Back-end/client-details/client-details.component';
  import { SearchPageComponent, PhonePipe } from './Components/Back-end/search-page/search-page.component';
  import { DeviceAppointmentQuestionaireComponent } from './Components/Front-end/device-appointment-questionaire/device-appointment-questionaire.component';
  import { DeviceAppointmentSearchComponent } from './Components/Front-end/device-appointment-search/device-appointment-search.component';

  import {MultiDatePicker} from './Components/multi-date-picker/multi-date-picker';
import { UserEditComponent } from './Components/Back-end/user-edit/user-edit.component'
import { NgxColorsModule } from 'ngx-colors';
import { ChatComponent } from './Components/Front-end/chat/chat.component';
import { Daterangepicker } from 'ng2-daterangepicker';
import { DeviceLogisticAppointmentQuestionaireComponent } from './Components/Front-end/device-logistic-appointment-questionaire/device-logistic-appointment-questionaire.component';
import { MainSignageDashboardComponent } from './Components/Back-end/main-signage-dashboard/main-signage-dashboard.component';
import { SignageLoginComponent } from './Components/Front-end/signage-login/signage-login.component';
//import { customTranslate } from './Services/Translate/custom-translate.loader';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { QrLoginComponent } from './Components/Back-end/qr-login/qr-login.component';
import { LogoutComponent } from './Components/Back-end/logout/logout.component';
import { PeopleCounterReportComponent } from './Components/Back-end/Report/people-counter-report/people-counter-report.component';
import { MainLayoutComponent } from './Components/main-layout/main-layout.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

const materialModules = [
  MatButtonModule,
  
];


// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

const routes: Routes = [
  {path: 'appoint', component: WelcomeComponent},
  {path: 'login', component: LoginComponent},
  {path: 'users', component: UsersComponent},
  {path: 'register', component: RegisterComponent,canActivate: [AuthGuardService]},
  {path: 'appointment-edit', component: AppointmentEditComponent,canActivate: [AuthGuardService]},
  {path: 'individual-user-fullview', component: IndividualUserFullviewComponent,canActivate: [AuthGuardService]},
  {path: 'welcome', component: WelcomeComponent},
  {path: 'main-menu', component: MainMenuComponent},
  {path: 'covid-assessment', component: CovidAssessmentComponent},
  {path: 'appointment-questionaire', component: AppointmentQuestionaireComponent},
  {path: 'appointment-search', component: AppointmentSearchComponent},
  {path: 'have-appointment-question', component: HaveAppointmentQuestionComponent},
  {path: 'main-dashboard', component: MainDashboardComponent,canActivate: [AuthGuardService]},
  {path: 'appointment-details', component: AppointmentDetailsComponent},
 // {path: '', redirectTo: '/welcome', pathMatch:'full'},
  {path: '**', redirectTo: '/welcome', pathMatch:'full'},
];



@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    MainMenuComponent,
    CovidAssessmentComponent,
    AppointmentQuestionaireComponent,
    HaveAppointmentQuestionComponent,
    AppointmentSearchComponent,
    MainDashboardComponent,
    AppointmentDetailsComponent,
    LoginComponent,
    SideBarMenuComponent,
    TopNavBarComponent,
    RegisterComponent,
    UsersComponent,
    IndividualUserFullviewComponent,
    AppointmentEditComponent,
    SalesRepHomeComponent,
    AllLocalAppointmentsComponent,
    LunchAssignmentComponent,
    CreateAppointmentComponent,
    DayViewSchedulerComponent,
   SalesRepTimetableComponent,
   ReportDashboardComponent,
   LogisticsMainComponent,
   CreateLogisticsSchedulesComponent,
   ScheduleDetailsComponent,
   ScheduleEditComponent,
   DateTimePickerComponent,
   AvailableAppointmentSlotComponent,
   ExternalLoginComponent,
   ScheduleAdministrationComponent,
   BranchReportComponent,
   ClientDetailsComponent,
   SearchPageComponent,
   PhonePipe,
   DeviceAppointmentQuestionaireComponent,
   DeviceAppointmentSearchComponent,
   MultiDatePicker,
   UserEditComponent,
   ChatComponent,
   SafePipe,
   DeviceLogisticAppointmentQuestionaireComponent,
   MainSignageDashboardComponent,
   SignageLoginComponent,
   QrLoginComponent,
   LogoutComponent,
   PeopleCounterReportComponent,
   MainLayoutComponent,
    //DemoComponent
  ],
  imports: [
    BrowserModule,
    DragDropModule,
    NgbTimepickerModule,
    AppRoutingModule,
    MatButtonModule,
    FormsModule, 
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    Ng2SearchPipeModule,
    NgxColorsModule,
    RouterModule,
    CommonModule,
    BsDatepickerModule.forRoot(), BrowserAnimationsModule,
    NgbDatepickerModule, NgbTimepickerModule,
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory },),
    BrowserAnimationsModule,
    DemoUtilsModule,
    ResizableModule,
    DragAndDropModule,
    DlDateTimeDateModule,  // <--- Determines the data type of the model
    DlDateTimePickerModule,
    Daterangepicker,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    TranslateModule.forRoot({
      loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
      }
    })
  ],
  providers: [AppointmentService,DatePipe,ExcelService,{provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }


